import { SITE } from "../lib/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A2B22] text-[#F9F9F6] mt-12"
    >
      <div className="px-6 md:px-12 lg:px-24 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-5">
            <img
              src="/logo-light.png"
              alt=""
              className="h-20 w-auto"
              draggable={false}
            />
            <div className="font-display text-4xl md:text-5xl tracking-tighter leading-[0.95]">
              {SITE.brand}
            </div>
          </div>
          <p className="mt-6 max-w-md text-[#F9F9F6]/70 leading-relaxed">
            {SITE.tagline}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#F9F9F6]/50 mb-5">
            Visit
          </p>
          <p className="text-[#F9F9F6]/90">{SITE.address}</p>
        </div>

        <div className="md:col-span-2">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#F9F9F6]/50 mb-5">
            Contact
          </p>
          <a
            data-testid="footer-email"
            href={`mailto:${SITE.email}`}
            className="block text-[#F9F9F6]/90 hover:text-[#E0B894] transition-colors"
          >
            {SITE.email}
          </a>
        </div>

        <div className="md:col-span-2">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#F9F9F6]/50 mb-5">
            Follow
          </p>
          <a
            href={SITE.social.instagram}
            data-testid="footer-instagram"
            className="block text-[#F9F9F6]/90 hover:text-[#E0B894]"
          >
            Instagram
          </a>
          <a
            href={SITE.social.facebook}
            data-testid="footer-facebook"
            className="block mt-2 text-[#F9F9F6]/90 hover:text-[#E0B894]"
          >
            Facebook
          </a>
        </div>
      </div>
      <div className="px-6 md:px-12 lg:px-24 py-6 border-t border-[#F9F9F6]/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#F9F9F6]/50">
        <p>© {new Date().getFullYear()} {SITE.brand}. All rights reserved.</p>
        <p className="tracking-[0.25em] uppercase">
          Czech Warmbloods · Hunters · Jumpers
        </p>
      </div>
    </footer>
  );
};

export default Footer;
